// extracted by mini-css-extract-plugin
export var container = "_fa-0";
export var content = "_fa-3";
export var customerTitle = "_fa-4";
export var empty = "_fa-5";
export var gray = "_fa-6";
export var header = "_fa-7";
export var info = "_fa-8";
export var loading = "_fa-2";
export var loadingCard = "_fa-9";
export var oneLine = "_fa-a";
export var personName = "_fa-e";
export var pillContainer = "_fa-b";
export var selected = "_fa-1";
export var text = "_fa-c";
export var twoLines = "_fa-d";
export var unread = "_fa-f";
export var unreadIndicator = "_fa-g";